import {useEffect, useState} from 'react';
import type {LanguageLocale} from "@/api/model";

function useBrowserLanguage() {
    const [language, setLanguage] = useState(() => getLanguage());

    useEffect(() => {
        const handleLanguageChange = () => setLanguage(getLanguage());

        window.addEventListener('languagechange', handleLanguageChange);
        return () => window.removeEventListener('languagechange', handleLanguageChange);
    }, []);

    return language;
}

function getLanguage(): LanguageLocale {
    if (typeof navigator === 'undefined') return 'de';

    const browserLang = (navigator.language || ('userLanguage' in navigator && navigator.userLanguage as string) || '')
        .toLowerCase()
        .split('-')[0]; // 'it-IT' -> 'it'

    return browserLang === 'it' || browserLang === 'de' ? browserLang : 'de';
}

export {useBrowserLanguage};
